import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalSavingAccontImage from "../../assets/static/personal/bank_transfer.png";

function DepositAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Deposit Account? We’ve got you covered."
        description="Kontriman offers multiple ways to assist you with your deposit account – help center, chat support, and email. Get the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Deposit Account</h1>
                  <p>
                    Our Deposit Account offers a secure place to store your
                    funds while earning competitive interest. It’s perfect for
                    individuals or businesses looking to keep their money safe,
                    accessible, and productive.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>Secure and insured savings</li>
                    <li>Attractive interest rates</li>
                    <li>Flexible deposit and withdrawal options</li>
                    <li>Online access and account management</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Valid national ID or passport</li>
                    <li>Proof of address</li>
                    <li>Minimum deposit requirement</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Deposit Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={personalSavingAccontImage}
                  alt="Deposit Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default DepositAccount;
